if (!customElements.get('miez-mobile-sticky-atc')) customElements.define('miez-mobile-sticky-atc', class extends HTMLElement {
  connectedCallback() {
    this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
    this.form = document.getElementById('product-form-' + this.dataset.sectionId);
    this.button = this.querySelector('button');
    if (!this.form) return;
    this.refresh = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    };
    this.onClick = () => {
      const source = this.source();
      if (!source || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
      source.click();
      this.update();
    };
    this.button.addEventListener('click', this.onClick);
    this.observer = new MutationObserver(this.refresh);
    this.observer.observe(this.form, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value']});
    this.section.addEventListener('change', this.refresh);
    window.addEventListener('scroll', this.refresh, {passive:true});
    window.addEventListener('resize', this.refresh);
    this.update();
  }
  source() { return this.form?.querySelector('[id^="ProductSubmitButton"]'); }
  update() {
    const source = this.source();
    if (!source) { this.hidden = true; return; }
    const busy = source.getAttribute('aria-disabled') === 'true' || source.classList.contains('loading');
    this.button.disabled = source.disabled || busy;
    this.button.setAttribute('aria-busy', String(busy));
    this.button.querySelector('span').textContent = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
    const values = [...this.section.querySelectorAll('variant-options input:checked')].map(input => input.value);
    if (values.length) this.querySelector('.miez-mobile-sticky-atc__selection').textContent = values.join(' / ');
    const rect = source.getBoundingClientRect();
    const headerBottom = document.querySelector('.page-header')?.getBoundingClientRect().bottom || 0;
    const visible = rect.bottom > Math.max(0,headerBottom) && rect.top < window.innerHeight;
    this.hidden = !window.matchMedia('(max-width:899px)').matches || window.scrollY < 80 || visible;
    document.body.classList.toggle('miez-mobile-atc-visible', !this.hidden);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.section?.removeEventListener('change', this.refresh);
    window.removeEventListener('scroll', this.refresh);
    window.removeEventListener('resize', this.refresh);
    this.button?.removeEventListener('click', this.onClick);
    document.body.classList.remove('miez-mobile-atc-visible');
  }
});
